export default "/images/NuMedis.svg?c81699106bc9f867cbda8416a9829089";